import { computed } from "@vue/composition-api";
import DocumentsLoader from "../../documents/components/documents-loader.vue";
import ApplicationPageLoader from "./page-loaders/application-page-loader.vue";
import FilogixPageLoader from "./page-loaders/filogix-page-loader.vue";
import DirectToLenderPageLoader from "./page-loaders/direct-to-lender-page-loader.vue";
import FormsPageLoader from "./page-loaders/forms-page-loader.vue";
import InternalNotesPageLoader from "./page-loaders/internal-notes-page-loader.vue";
import ServicesPageLoader from "./page-loaders/services-page-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationPageContainerLoader",
  components: {
    ApplicationPageLoader,
    DocumentsLoader,
    FilogixPageLoader,
    DirectToLenderPageLoader,
    FormsPageLoader,
    InternalNotesPageLoader,
    ServicesPageLoader
  },
  props: {
    currentPage: {
      type: String,
      default: "application"
    }
  },
  setup(props) {
    const componentMap = {
      application: "ApplicationPageLoader",
      documents: "DocumentsLoader",
      filogix: "FilogixPageLoader",
      "direct-to-lender": "DirectToLenderPageLoader",
      forms: "FormsPageLoader",
      "internal-notes": "InternalNotesPageLoader",
      services: "ServicesPageLoader"
    };
    const currentPageLoaderComponent = computed(() => componentMap[props.currentPage]);
    return {
      currentPageLoaderComponent
    };
  }
});